import * as UI from "@iyk/ui"

import { Card } from "@iyk/vf-ui"
import { LogoutButton } from "../../auth/ui/logout-button.tsx"
import { VerifiedProfileIcon } from "../../profile/ui/icons.tsx"
import { Sheet } from "./sheet.tsx"

export const UserMenu = (props: UserMenu.Props) => {
  return (
    <Sheet.Root>
      <Sheet.Trigger asChild>
        <UI.Button type="button" kind="shaded" size="sm" className="absolute top-4 right-4 z-50">
          <UI.Icon.Profile />
        </UI.Button>
      </Sheet.Trigger>
      <Sheet.Content title="Profile" description="Manage your profile">
        <div className="flex flex-col gap-4 px-4 pt-10 pb-4">
          <Card className="flex justify-between p-4">
            <div className="flex items-center gap-2">
              <span className="text-[18px] leading-6 uppercase font-departure-mono">{props.username}</span>
              <VerifiedProfileIcon />
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <UI.Icon.Location />
                <span className="text-xs">{props.totalCheckIns}</span>
              </div>
              <div className="flex items-center gap-2">
                <UI.Icon.Badge />
                <span className="text-xs">{props.totalMerchOwned}</span>
              </div>
            </div>
          </Card>
          <LogoutButton
            formClassName="w-full h-12 cursor-pointer text-sm text-gray-11 flex items-center"
            buttonClassName="flex-1 text-left"
          />
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}

namespace UserMenu {
  export type Props = {
    username: string
    totalCheckIns: number
    totalMerchOwned: number
  }
}
